// extracted by mini-css-extract-plugin
export default {"root":"_11wwV","reaction":"_12Uuf","reaction-icon":"_1u8k2","reactionIcon":"_1u8k2"};